
import React, { useEffect } from "react";
import "./RegalContact.scss"
import Contact from "../../components/Contact/Contact";
const RegalContact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="RegalContact">
            <div className="RegalContact-hero">
                <div className="RegalContact-hero-header">
                    Visit Us
                </div>
                <div className="RegalContact-hero-subheader">
                    Find Us on Leicester's Golden Mile
                </div>
            </div>

            <div className="RegalContact-container">
                <Contact />
            </div>
        </div>
    )
}
export default RegalContact